<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/cross.svg")
    h2.modal__title Восстановление пароля
    p.modal__text Введите адрес электронной почты, на которую зарегистрирован кабинет
    .modal__form
      form
        .form
          .form__elem
            .form-elem(
              :class="{'form-elem_error' : error}"
            )
              .form-elem__title Email
              .form-elem__main
                input(
                type="email"
                v-model="email"
                @input="onInputChange"
                ).input.input_full
          .form__elem
            .form-elem
              .form-elem__main
                button.button.button_paint-main.button_full(
                @click.prevent="onButtonClick"
                :class="{'loaded-button':isPending}"
                )
                  .button__text Восстановить
                .form-elem__error(
                  v-if="showErrorMessage"
                ) Данный пользователь не существует или email не подтвержден, проверьте почту.
    .modal__links.modal-links
      .modal-links__link
        a.link(
        @click.prevent="$emit('changeModalMode', 'sign-up')"
        ) Регистрация
      .modal-links__link
        a.link(
        @click.prevent="$emit('changeModalMode', 'sign-in')"
        ) Вход на сайт

</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "reset-password",
  data() {
    return {
      email: "",
      error: false,
      showErrorMessage: false,
      isPending: false,
    };
  },
  methods: {
    ...mapActions(["resetPassword"]),
    onInputChange() {
      this.error = false;
      this.showErrorMessage = false;
    },
    onButtonClick() {
      let emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.email.length === 0 || !emailReg.test(this.email)) {
        this.error = true;
        return false;
      }
      this.isPending = true;
      this.resetPassword({ email: this.email }).then((res) => {
        this.isPending = false;
        if (res.status === 404) {
          this.error = true;
          this.showErrorMessage = true;
        } else if (res.status === 200) {
          this.$emit("changeModalMode", "notification", {
            title: "Проверьте почту",
            text: `Мы выслали ссылку для восстановления пароля на ${this.email}`,
          });
        }
      });
    },
  },
};
</script>
